export default __webpack_public_path__ + "static/media/CNo.62-5.e2c669ee.jpg";